import { PosSystem } from 'utils/generated';

export const isPosSystem = (input: unknown): input is typeof PosSystem => {
    const posSystemsArray = Object.keys(PosSystem);
    return posSystemsArray.includes(input as string);
};

export default { isPosSystem };
